export default __webpack_public_path__ + "static/media/star-2-3.2de938e0.svg";